import { api } from './client'

export const listPrograms = () => api.get('/programs').then((r) => r.data)
export const getProgram = (pid) => api.get(`/programs/${pid}`).then((r) => r.data)
// Hanya SUPER_ADMIN (server yang menegakkan). Kode, tingkat, dan warna divalidasi
// server; lembaga diambil dari token, bukan dari isi permintaan.
export const createProgram = (data) => api.post('/programs', data).then((r) => r.data)
// data pakai nama kolom apa adanya (snake_case) — endpoint ini meneruskannya
// langsung ke Prisma tanpa pemetaan, beda dari kebanyakan endpoint lain.
export const updateProgram = (pid, data) => api.put(`/programs/${pid}`, data).then((r) => r.data)
export const listEnrollments = (pid) => api.get(`/programs/${pid}/enrollments`).then((r) => r.data)

// ─── Kelas ───────────────────────────────────────────────────────────────────
// Satu kali penyelenggaraan program. Peserta, sesi, dan mode inhouse/publik
// menempel di sini; materi dan tes tetap milik programnya.
export const listClasses = (pid) => api.get(`/programs/${pid}/classes`).then((r) => r.data)
export const getClass = (pid, cid) =>
  api.get(`/programs/${pid}/classes/${cid}`).then((r) => r.data)
export const createClass = (pid, data) =>
  api.post(`/programs/${pid}/classes`, data).then((r) => r.data)
export const updateClass = (pid, cid, data) =>
  api.put(`/programs/${pid}/classes/${cid}`, data).then((r) => r.data)
// Apa yang ikut terhapus bersama kelasnya — dibaca lebih dulu supaya angkanya
// bisa dipampang sebelum ada yang menekan Hapus.
export const classDeleteImpact = (pid, cid) =>
  api.get(`/programs/${pid}/classes/${cid}/delete-impact`).then((r) => r.data)
// `confirm` wajib berisi nama kelas persis bila kelasnya sudah terpakai.
export const deleteClass = (pid, cid, confirm) =>
  api.delete(`/programs/${pid}/classes/${cid}`, { data: confirm ? { confirm } : {} }).then((r) => r.data)
export const listClassEnrollments = (pid, cid) =>
  api.get(`/programs/${pid}/classes/${cid}/enrollments`).then((r) => r.data)
// FR-30: the caller's own enrollment (for the Welcome onboarding gate)
export const getMyEnrollment = (pid) =>
  api.get(`/programs/${pid}/enrollments/me`).then((r) => r.data)
export const markOnboarded = (pid) =>
  api.patch(`/programs/${pid}/enrollments/me/onboarded`).then((r) => r.data)
// `classId` opsional. Tanpa itu pesertanya masuk sebagai enrolmen tak-berkelas,
// yang masih sah tapi tidak muncul di daftar kelas mana pun.
export const enrollParticipant = (pid, userId, classId) =>
  api
    .post(`/programs/${pid}/enrollments`, classId ? { userId, classId } : { userId })
    .then((r) => r.data)
// Kode pendaftaran mandiri — jalan masuk peserta yang datanya belum pernah ada
// di sistem. Menempel di KELAS, bukan program: sebuah program dijalankan
// berkali-kali, jadi kode se-program tidak bisa memberi tahu angkatan mana yang
// dimasuki peserta.
export const openJoinCode = (pid, cid, hours) =>
  api.post(`/programs/${pid}/classes/${cid}/join-code`, hours ? { hours } : {}).then((r) => r.data)
export const closeJoinCode = (pid, cid) =>
  api.delete(`/programs/${pid}/classes/${cid}/join-code`).then((r) => r.data)

export const generateParticipantQR = (pid, eid) =>
  api.post(`/programs/${pid}/enrollments/${eid}/qr`).then((r) => r.data)
export const emailParticipantQR = (pid, eid) =>
  api.post(`/programs/${pid}/enrollments/${eid}/qr/email`).then((r) => r.data)
export const createParticipant = (pid, payload) =>
  api.post(`/programs/${pid}/participants`, payload).then((r) => r.data)

export const downloadParticipantImportTemplate = (pid) =>
  api
    .get(`/programs/${pid}/participants/import/template`, { responseType: 'blob' })
    .then((r) => r.data)

export const downloadParticipantImportTemplateXlsx = (pid) =>
  api
    .get(`/programs/${pid}/participants/import/template.xlsx`, { responseType: 'blob' })
    .then((r) => r.data)

// PDF-nya lembar RUJUKAN, bukan formulir: ia tidak bisa diunggah balik, gunanya
// dicetak lalu diberikan ke perusahaan klien yang mengumpulkan data pesertanya.
export const downloadParticipantImportTemplatePdf = (pid) =>
  api
    .get(`/programs/${pid}/participants/import/template.pdf`, { responseType: 'blob' })
    .then((r) => r.data)

// Mengurai berkas di server tanpa menyentuh basis data, supaya langkah review
// menampilkan apa yang BENAR-BENAR dibaca server — bukan hasil parser kedua di
// peramban yang bisa berbeda pendapat (dan tidak bisa membaca .xlsx sama sekali).
export const previewParticipantImport = (pid, file) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/programs/${pid}/participants/import/preview`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

export const importParticipantsCSV = (pid, file, { sendQrEmail = false, classId = null } = {}) => {
  const fd = new FormData()
  fd.append('file', file)
  if (sendQrEmail) fd.append('sendQrEmail', 'true')
  // Hanya dikirim bila ada. Mengirim string kosong membuat server mencari kelas
  // bernama "" lalu menjawab 404 untuk impor yang sah tanpa kelas.
  if (classId) fd.append('classId', classId)
  return api
    .post(`/programs/${pid}/participants/import`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((r) => r.data)
}

// ─── Trainer assignment ─────────────────────────────────────────────────────
export const listProgramTrainers = (pid) =>
  api.get(`/programs/${pid}/trainers`).then((r) => r.data)
export const assignTrainer = (pid, payload) =>
  api.post(`/programs/${pid}/trainers`, payload).then((r) => r.data)
export const unassignTrainer = (pid, userId) =>
  api.delete(`/programs/${pid}/trainers/${userId}`).then((r) => r.data)
export const getPendingTrainerAssignments = () =>
  api.get('/programs/trainer/assignments/pending').then((r) => r.data)
export const acknowledgeTrainerAssignments = () =>
  api.post('/programs/trainer/assignments/acknowledge').then((r) => r.data)
